// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Konto } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetKonto(): (kontoId: string) => Promise<Konto> {
  const getAPI = useGetApi();
  return useCallback(
    async (kontoId) => (await getAPI()).konten.getKonto({ kontoId }),
    [getAPI]
  );
}
